// User data management utilities
export interface UserData {
  cms_id: string;
  [key: string]: any;
}

export const getUserFromSession = (): UserData | null => {
  if (typeof window === 'undefined') return null;
  
  try {
    const userDataString = sessionStorage.getItem("userData");
    if (!userDataString) return null;
    
    const userData = JSON.parse(userDataString);
    return userData;
  } catch (error) {
    console.error("Error parsing user data from session:", error);
    return null;
  }
};

export const saveUserToSession = (userData: UserData): void => {
  if (typeof window === 'undefined') return;
  
  try {
    sessionStorage.setItem("userData", JSON.stringify(userData));
  } catch (error) {
    console.error("Error saving user data to session:", error);
  }
};

export const clearUserFromSession = (): void => {
  if (typeof window === 'undefined') return;
  
  try {
    sessionStorage.removeItem("userData");
  } catch (error) {
    console.error("Error clearing user data from session:", error);
  }
};

export const validateUserData = (userData: any): userData is UserData => {
  return userData && 
         typeof userData === 'object' && 
         typeof userData.cms_id === 'string' && 
         userData.cms_id.trim() !== '';
};
